import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../service/notification.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormControl, NgForm } from '@angular/forms';
import { ReportModel } from '../report.model';
import { ScheduleModel } from '../schedule.model';
import { ReportService } from '../report.service';
import { DistributionModel } from '../distribution.model';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { RefreshService } from '../refresh.service';
import { MyDocsModel } from 'src/app/models/upload/mydocs.model';
import { MyDocsService } from 'src/app/service/mydocs.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-distribution-create',
  templateUrl: './distribution-create.component.html',
  styleUrls: ['./distribution-create.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DistributionCreateComponent implements OnInit, AfterViewInit {


  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public ctype: string;
  reposnseData: ReportModel[] = [];
  selectedIds: DistributionModel[] = [];
  isChecked: boolean = false;

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  //fileName: string = 'ReportsData';

  public reportModel = new ReportModel();
  public scheduleModel = new ScheduleModel('', '', '', '', '', '');
  public distributionModel = new DistributionModel(0, 0, '', '', '', null, '', '', '', 0, '', '', false);
  public myDocsModel = new MyDocsModel();

  public displayedColumns = ['Select', 'distName', 'distType', 'update'];
  public dataSource = new MatTableDataSource<DistributionModel>();

  public displayedColumnValues = ['empName', 'delete'];
  public dataSourceValues = new MatTableDataSource<DistributionModel>();

  public rolesData: MyDocsModel[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  supervisorNamesSet = new Set<string>();
  public showLoading: boolean;

  isEmpShown: boolean = false;
  isRoleShown: boolean = false;
  isEmpEditShown: boolean = false;
  isRoleEditShown: boolean = false;
  reposnseEmpData: DistributionModel[] = [];
  responseRoleData: DistributionModel[] = [];
  excelDistList: DistributionModel[] = [];
  public reportModelQuery = new ReportModel();
  distty: string;
  distId: number;

  filteredEmpOptions: Observable<any[]>;
  myControlEmp = new FormControl();

  expandedElement: null;

  // START ====================================================

  @Output() result = new EventEmitter<{ key: string, data: Array<string> }>();

  @Input() placeholder: string = 'Select Employee';
  @Input() data: Array<DistributionModel> = [];
  @Input() key: string = '';

  selectControl = new FormControl();

  rawData: Array<DistributionModel> = [];
  selectData: Array<DistributionModel> = [];

  filteredData: Observable<Array<DistributionModel>>;
  filterString: string = '';
  selectedEmpIds: string = "";

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];


  // END ====================================================

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private router: Router, private reportService: ReportService,
    public ete: ExportExcelService, private httpService: HttpClient,
    private notificationService: NotificationService, private refreshService: RefreshService,
    private myDocsService: MyDocsService) {

    this.filteredData = this.selectControl.valueChanges.pipe(
      startWith<string>(''),
      map(value => typeof value === 'string' ? value : this.filterString),
      map(filter => this.filter(filter))
    );
  }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('create-report');

    this.refreshService.notifyObservable$.subscribe(res => {
      if (res.refresh) {
        console.log("Refresh Distribution");
        this.getReports();
      }
    })

    this.getReports();
    this.getRoles();
    this.getUserTypesList();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.reportDistribution;
      }
    );
  }

  exportExcel() {
    for (let js of this.excelDistList) {
      delete js.id;
      delete js.distId;
      delete js.distValue;
      delete js.createdDt;
      delete js.createdBy;
      delete js.empId;
      delete js.empName;
      delete js.userId;
      delete js.roleName;
      delete js.email;
      delete js.selected;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelDistList.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'ReportDistribution',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public getUserTypesList(): void {
    this.subscriptions.push(
      this.myDocsService.getUserTypesList().subscribe(
        (response: MyDocsModel[]) => {
          this.rolesData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }
  public onChangeGetEmployees(event) {
    this.myDocsModel.user_type = event.target.value;
    console.log("this.myDocsModel.user_type = " + this.myDocsModel.user_type);
    this.getEmployees(this.myDocsModel.user_type);
  }


  public getEmployees(filter: string): void {
    console.log("inside getEmployees===" + filter);
    this.subscriptions.push(
      this.reportService.getEmployees(filter).subscribe(
        (response: DistributionModel[]) => {
          console.log("response = " + JSON.stringify(response));
          this.data = response;
          this.rawData = response;
          console.log("this.rawData = " + JSON.stringify(this.rawData));

          this.filteredData = this.selectControl.valueChanges.pipe(
            startWith<string>(''),
            map(value => typeof value === 'string' ? value : this.filterString),
            map(filter => this.filter(filter))
          );
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  // START =====================================================================================================
  filter = (filter: string): Array<DistributionModel> => {
    console.log("inside filter");
    this.filterString = filter;
    console.log("filter.length = " + filter.length);
    if (filter.length > 0) {
      return this.rawData.filter(option => {
        return option.empName.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return this.rawData.slice();
    }
  };

  //displayFn = (): string => '';

  public displayFunction(distri: string) {
    console.log("distri === " + distri);
    return this.rawData.find(distribute => distribute.empId === distri).empName;
  }

  optionClicked = (event: Event, data: DistributionModel): void => {
    event.stopPropagation();
    this.toggleSelection(data);
  };

  toggleSelection = (data: DistributionModel): void => {
    data.selected = !data.selected;

    if (data.selected === true) {
      this.selectData.push(data);
    } else {
      const i = this.selectData.findIndex(value => value.empName === data.empName);
      this.selectData.splice(i, 1);
    }

    this.selectControl.setValue(this.selectData);
    this.emitAdjustedData();
  };

  emitAdjustedData = (): void => {
    const results: Array<string> = []
    var rest: string = "";
    console.log("this.selectData===" + JSON.stringify(this.selectData));
    this.selectData.forEach((data: DistributionModel) => {
      rest = rest + data.empId + ",";
      this.selectedEmpIds = rest.slice(0, -1);
      this.distributionModel.distValue = this.selectedEmpIds;
      results.push(data.empName);
      //console.log("results==="+JSON.stringify(results));
      //console.log("this.selectedEmpIds==="+JSON.stringify(this.selectedEmpIds));
      //console.log("this.distributionModel.distValue==="+this.distributionModel.distValue);
    });
    this.result.emit({ key: this.key, data: results });
    console.log("this.result===" + JSON.stringify(this.result));
  };

  removeChip = (data: DistributionModel): void => {
    this.toggleSelection(data);
  };

  // END =============================================================================================

  public insertDisribution(distForm: NgForm) {
    console.log("insertDisribution from create Distribution");
    console.log("distValue === " + this.distributionModel.distValue);
    console.log("distForm.value === " + JSON.stringify(this.selectData));

    this.showLoading = true;
    const formData = this.reportService.createDistForm(distForm.value, this.distributionModel.distValue);
    this.subscriptions.push(
      this.reportService.addDistribution(formData).subscribe(
        (response: DistributionModel) => {
          this.clickButton('closeAddButton');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
          this.getReports();
          distForm.reset();
          this.showLoading = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          this.showLoading = false;
        }
      )
    );
  }

  public onDeleteValue(id: number): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {

      console.log("delete id === " + id);
      if (confirm("Are you sure to delete this value")) {
        this.subscriptions.push(
          this.reportService.deleteValue(id).subscribe(
            (response: CustomHttpRespone) => {
              this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
              this.getReports();
            },
            (error: HttpErrorResponse) => {
              this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
            }
          )
        );
      }
    }
  }

  public getDistId(distId: number, distType: string) {
    console.log("distId===" + distId);
    console.log("distType===" + distType);
    this.distId = distId;
    this.getDistValues(this.distId, distType);
  }
  public getDistValues(distId: number, distType: string) {
    this.reportService.getDistValues(distId, distType)
      .subscribe((res: any) => {
        this.dataSourceValues = res;
      });
  }

  public getReports(): void {
    console.log("getReports from create Distribution");
    this.subscriptions.push(
      this.reportService.getDistributionList().subscribe(
        (response: DistributionModel[]) => {
          this.dataSource.data = response;
          console.log(JSON.stringify(response));
          this.excelDistList = JSON.parse(JSON.stringify(response));
          //console.log("create Distribution getReports this.dataSource.data = " + JSON.stringify(this.dataSource.data));
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public getRoles(): void {
    this.subscriptions.push(
      this.reportService.getRoles().subscribe(
        (response: DistributionModel[]) => {
          this.responseRoleData = response;
          console.log("Roles = " + JSON.stringify(this.responseRoleData));
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }




  public onUpdateDisribution(): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {

      const formData = this.reportService.createDistForm(this.distributionModel, 'NA');
      this.subscriptions.push(
        this.reportService.onUpdateDisribution(formData).subscribe(
          (response: DistributionModel) => {
            this.clickButton('closeEditModalButton');
            this.getReports();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }
  }

  public selectedCalIds(rep: DistributionModel, values: any) {
    console.log('calc values == ' + JSON.stringify(values));
    this.distributionModel = rep;
    if (values.currentTarget.checked) {
      this.selectedIds.push(this.distributionModel);
    } else {
      this.selectedIds = [];
      this.selectedIds.forEach((value: any, index: any) => {
        if (value.id == rep.id) this.selectedIds.splice(index, 1);
      });
    }
    console.log('selectedIds == ' + JSON.stringify(this.selectedIds));
  }
  public onDeleteDistribution() {
    console.log("aa selctedKpis : " + JSON.stringify(this.selectedIds));
    this.reportService.onDeleteDistribution(this.selectedIds)
      .subscribe(response => {
        //this.getInactiveKpis(false);
        this.getReports();
        response = response as ErrorResponseMessage;
        //console.log('updateKpiStatus response === ', response);
        this.selectedIds = [];
        this.isChecked = false;
      })
  }

  toggleShow(event: any) {
    //alert(event.currentTarget.value);
    if (event.currentTarget.value === "By User") {
      this.isEmpShown = true;
      this.isRoleShown = false;
    } else {
      this.isEmpShown = false;
      this.isRoleShown = true;
    }

  }
  toggleEditShow(event: any) {
    //alert(event.currentTarget.value);
    if (event.currentTarget.value === "By User") {
      this.isEmpEditShown = true;
      this.isRoleEditShown = false;
    } else {
      this.isEmpEditShown = false;
      this.isRoleEditShown = true;
    }
  }

  public onEditDist(distModel: DistributionModel): void {
    this.distty = distModel.distType;
    console.log("this.distty == " + this.distty);
    if (this.distty === "By User") {
      console.log("By User");
      this.isEmpEditShown = true;
      this.isRoleEditShown = false;
    } else {
      console.log("By Role");
      this.isEmpEditShown = false;
      this.isRoleEditShown = true;
    }
    this.distributionModel = distModel;
    this.clickButton('openEditModel');
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public runReport(sqlquery: string, reportName: string) {
    console.log("SQL Query === " + sqlquery);

    this.reportModelQuery.reportSql = sqlquery;
    this.reportModelQuery.sqlParams = 'NA';
    console.log(this.reportModelQuery);

    this.reportService.runReport(this.reportModelQuery)
      .subscribe((response: any) => {
        console.log("Response = " + JSON.stringify(response));
        this.reposnseData = response;
        //this.exportExcel(reportName);
      });
  }

  public onUpdateSchedule(): void {
    const formData = this.reportService.createScheduleForm(this.scheduleModel);
    this.subscriptions.push(
      this.reportService.onUpdateSchedule(formData).subscribe(
        (response: ReportModel) => {
          this.clickButton('closeScheduleModalButton');
          this.getReports();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }






  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }



  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


}



